import type { NavigationGuard, RouteRecordRaw } from 'vue-router'

import { useFeatureFlags } from '@/composables/useFeatureFlags'
import useHasPermissionUser from '@/composables/useHasPermissionUser'

// Interruptor maestro de vuelos. Si está deshabilitado (por default en el build de
// producción hasta lanzarlo, o con VITE_FLIGHTS_ENABLED=false), bloquea el acceso por URL
// a CUALQUIER pantalla de vuelos — no basta con ocultarla del menú. Va en los hijos porque
// la ruta padre tiene `redirect` y Vue Router no ejecuta beforeEnter en rutas que redirigen.
const flightsGuard: NavigationGuard = (_to, _from, next) => {
	const { flightsEnabled } = useFeatureFlags()
	if (!flightsEnabled) {
		return next({ path: '/error/not-found' })
	}
	return next()
}

export default {
	path: '/services/plane',
	redirect: '/services/plane/search',
	children: [
		{
			path: 'search',
			name: 'plane.search',
			component: () => import('@/modules/planes/pages/FlightSearchPage.vue'),
			beforeEnter: [
				flightsGuard,
				(_to, _from, next) => {
					const { hasPermissionUser } = useHasPermissionUser()

					if (
						hasPermissionUser('create-flight', 'App\\Models\\Request') ||
						hasPermissionUser('create-hotel', 'App\\Models\\Request')
					) {
						return next()
					} else {
						return next({
							path: '/error/not-found',
						})
					}
				},
			],
		},
		{
			path: 'details',
			name: 'plane.details',
			component: () => import('@/modules/planes/pages/FlightDetailsPage.vue'),
			beforeEnter: flightsGuard,
		},
		{
			path: 'booking',
			name: 'plane.booking',
			component: () => import('@/modules/planes/pages/FlightBookingPage.vue'),
			beforeEnter: flightsGuard,
		},
		{
			path: 'reservations',
			name: 'plane.reservations',
			component: () =>
				import('@/modules/planes/pages/FlightReservationsPage.vue'),
			beforeEnter: flightsGuard,
		},
		{
			path: 'confirmation/:pnr',
			name: 'flight.confirmation',
			component: () =>
				import('@/modules/planes/pages/FlightConfirmationPage.vue'),
			beforeEnter: flightsGuard,
		},
		{
			path: 'reservation/:pnr',
			name: 'flight.reservation',
			component: () =>
				import('@/modules/planes/pages/FlightReservationPage.vue'),
			beforeEnter: flightsGuard,
		},
	],
} as RouteRecordRaw
